import React from 'react';

export const GuidedMask = ({ fillColor, ...props }) => (
  <svg
    {...props}
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 430 510"
    width="434"
    height="515"
  >
    <title>Guided Tours – Desktop-svg</title>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
        <path d="m-245-39h920v588h-920z" />
      </clipPath>
    </defs>
    <g id="Clip-Path" clipPath="url(#cp1)">
      <g id="Layer">
        <path
          id="Layer"
          fill={fillColor || '#000000'}
          d="m91.4-0.3h338.6v460.8l-173.1 43.8-252.1-207.1z"
        />
      </g>
    </g>
  </svg>
);

export default GuidedMask;
